<template>
  <v-dialog v-model="dialog" max-width="600">
    <data-loader :is_on="is_saving"  :is_saving="is_saving"/>
    <v-card class="universal-vcard">
      <v-card-title>
        <div class="universal-vdialog-title">
          <span>{{ $t('office_management.service_group.' + (isEditMode ? 'edit' : 'add')) }} {{ $t('office_management.service_group.group') }}</span>
        </div>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="formValid">
          <v-text-field
            v-model="formData.name"
            :label="$t('office_management.service_group.name')"
            :rules="[rules.required]"
            class="universal-vdialog-textfield"
            required
          ></v-text-field>

          <div class="form-input-wrapper" style="padding: 0.3vw;">
            <div>
              <label class="form-label" >
                <span>{{ $t('office_management.service_group.purchase_category') }}</span>
              </label>
              <CustomDropdown
                :id="'drop_sifarnik_type'"
                v-model="formData.purchase_type"
                style="font-size: 0.8vw;"
                :drop_items="
                  services.map((p) => {
                    return {
                      naziv: p.name,
                      id: p.id,
                    };
                  })
                "
              />
            </div>
          </div>

          <div class="container">
            <div class="form-input-wrapper">
              <label class="form-label">
                <span>{{ $t('office_management.service_group.detailed_description') }}</span>
              </label>
              <textarea
                class="form-textarea"
                v-model="formData.description"
                label="Description"
                :rules="[rules.required]"
                required
              ></textarea>
            </div>
          </div>

          <div class="space-between">
          <div class="form-input-wrapper">
            <label class="form-label">
              <span>{{ $t('office_management.service_group.total_paid') }}</span>
            </label>
            <input
              type="text"
              class="form-input"
              v-model="formData.total_cost"
              oninput="this.value = this.value.replace(',','.').replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
            />
          </div>
          <div class="form-input-wrapper">
            <label class="form-label">
              <span>{{ $t('office_management.service_group.tax_deducted') }}</span>
            </label>
            <input
              type="text"
              class="form-input"
              v-model="formData.tax_deducted"
              oninput="this.value = this.value.replace(',','.').replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
            />
          </div>
         
        </div>

          <v-menu
            ref="menu1"
            v-model="fromDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :label="$t('office_management.service_group.select_start_date')"
                v-model="dateText"
                readonly
                append-icon="mdi-calendar"
                v-bind="attrs"
                @click="fromDateMenu = !fromDateMenu"
                v-on="on"
                class="case-date-picker archive-date-picker"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="hr"
              :first-day-of-week="1"
              v-model="formData.from_timestamp"
              no-title
            ></v-date-picker>
          </v-menu>

          <v-menu
            ref="menu1"
            v-model="deadlineDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :label="$t('office_management.service_group.select_end_date')"
                v-model="deadlineText"
                readonly
                append-icon="mdi-calendar"
                v-bind="attrs"
                @click="deadlineDateMenu = !deadlineDateMenu"
                v-on="on"
                class="case-date-picker archive-date-picker"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="hr"
              :first-day-of-week="1"
              v-model="formData.deadline_timestamp"
              no-title
            ></v-date-picker>
          </v-menu>

          <div class="container">
            <form-files-upload
            v-if="fileUploadReady"
              :deleted_items.sync="files.deleted"
              :existing_items.sync="files.previous"
              :new_items.sync="files.new"
              :is_single_upload="false"
              :can_download="true"
              @getFile="getAttachment"
            />
          </div>
        </v-form>
      </v-card-text>

      <div class="vdialog-buttons-wrapper wrapper-three-buttons">
        <div
          class="universal-vdialog-button vbutton-secondary"
          text
          @click="close()"
        >
          {{ $t('office_management.service_group.cancel') }}
        </div>
        <div
          class="universal-vdialog-button vbutton-primary"
          text
          @click="is_saving ? '' : save()"
        >
          {{ is_saving ? $t('office_management.service_group.saving') : $t('office_management.service_group.save') }}
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import formFilesUpload from "../formElements/formFilesUpload.vue";
import projCaller from "@/apiCallers/promise_handler_db/projects";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import graph from '../../services/graph';
import { createPurchaseGroup, updatePurchaseGroup } from '../../apiCallers/promise_handler_db/officeManagement';
import DataLoader from '../generalComponents/DataLoader.vue';

export default {
  components: { formFilesUpload, CustomDropdown, DataLoader },
  name: "OfficeServiceGroupDialog",
  props: {
    services: Array,
  },
  data() {
    return {
      dialog: false,
      is_saving : false,
      fileUploadReady : false,
      formData: {
        id: "",
        name: "",
        description: "",
        from_timestamp: null,
        deadline_timestamp: null,
        files: [],
        purchase_type: null,
        total_cost : null,
        tax_deducted : null
      },

      emptyFormData : {
        name: "",
        description: "",
        from_timestamp: null,
        deadline_timestamp: null,
        files: [],
        purchase_type: null,
        total_cost : null,
        tax_deducted : null
      },


      files: {
        deleted: [],
        previous: [],
        new: [],
      },

      empty_files: {
        deleted: [],
        previous: [],
        new: [],
      },


      dateRangeText: null,
      isEditMode: false,
      formValid: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
      fromDateMenu: false,
      deadlineDateMenu: false,
    };
  },
  computed: {
    dateText() {
      return this.formData.from_timestamp
        ? moment(this.formData.from_timestamp).format("DD.MM.yyyy")
        : "";
    },
    deadlineText() {
      console.log(this.formData.deadline_timestamp)
      return this.formData.deadline_timestamp
        ? moment(this.formData.deadline_timestamp).format("DD.MM.yyyy")
        : "";
    },
  },
  methods: {
    async getAttachment(attach_id, file_name) {
      this.accessToken = this.$store.state.aToken;
      await projCaller
        .getTaskAttachment(this.group_url, attach_id)
        .then((resp) => {
          //pripremanje download linka
          var link = document.createElement("a");
          link.setAttribute("href", resp.data.webUrl);
          link.setAttribute("target", "_blank");
          link.setAttribute("download", file_name);
          link.click();
        });
    },
   async open(data = null) {
      this.dialog = true;
      this.fileUploadReady = false
      this.files = this.empty_files
      if (data) {
        this.isEditMode = true;
        console.log(data)
        this.formData = data
        
        this.files.previous = await graph.getMultipleFiles(data.links)

        this.fileUploadReady = true

      } else {
        this.isEditMode = false;
        this.formData = this.emptyFormData;
        this.files = this.empty_files
        this.fileUploadReady = true
      }
    },
    close() {
      this.dialog = false;
    },
    save() {
      this.is_saving = true;
      const method = this.isEditMode ? updatePurchaseGroup : createPurchaseGroup;
      
      if (this.$refs.form.validate() && this.formData.purchase_type && this.formData.name.trim().length > 2) {
        this.formData.files = this.files;
        if(!this.isEditMode)
        {
          delete this.formData.id
        }
        method(this.formData).then(() => {
          this.is_saving = false;
          this.$emit("refresh");
          this.close();
        })
        .catch((error) => {
          console.error("Failed to save knowledge entry:", error);
          alert("Neuspjelo spremanje podataka. Molimo provjerite tražene podatke.")
          this.is_saving = false;
        });
      }else{
        alert("Molimo unesite naziv i kategoriju nabave.")
        this.is_saving = false;
      }
    },
  },
};
</script>
